export const environment = {
  production: false,
  url: 'https://dev.teveni.app',
  apiUrl: 'https://dev.teveni.app/api',
  deliveryUrl: 'https://delivery.dev.teveni.app',
  teveniEmail: 'app.teveni@gmail.com',
  instagramUrl: 'https://www.instagram.com/',
  facebookUrl: 'https://www.facebook.com/',
  tiktokUrl: 'https://www.tiktok.com/',
};
